interface RecipeTypeComponentPickerProps {
    isFoodbox: boolean;
    recipeSlot: React.ReactNode;
    foodboxSlot: React.ReactNode;
}

const RecipeTypeComponentPicker = (props: RecipeTypeComponentPickerProps) => {
    return props.isFoodbox ? props.foodboxSlot : props.recipeSlot;
};

export default RecipeTypeComponentPicker;
